import React from 'react';
import { Modal, Button } from 'react-bootstrap'
import { t } from '../locale'

interface ExtractedData {
    firstName?: string | null
    lastName?: string | null
    dateOfBirth?: string | null
    dateOfExpiration?: string | null
    nationality?: string | null
    idNumber?: string | null
    gender?: string | null
}

const FIELD_KEYS: { key: keyof ExtractedData, labelKey: string }[] = [
    { key: 'firstName',        labelKey: 'firstName' },
    { key: 'lastName',         labelKey: 'lastName' },
    { key: 'dateOfBirth',      labelKey: 'dateOfBirth' },
    { key: 'dateOfExpiration', labelKey: 'dateOfExpiration' },
    { key: 'nationality',      labelKey: 'nationality' },
    { key: 'idNumber',         labelKey: 'idNumber' },
    { key: 'gender',           labelKey: 'gender' },
]

interface Props {
    show: boolean
    data: ExtractedData | null
    fieldResults: { field: string, valid: boolean }[]
    onConfirm: () => void
    position?: 'left' | 'right' | 'center'
    backdrop?: boolean
}

export default function ExtractedDataModal({ show, data, fieldResults, onConfirm, position = 'center', backdrop = true }: Props) {
    const validityMap = Object.fromEntries(fieldResults.map(r => [r.field, r.valid]))

    return (
        <Modal
            show={show}
            centered
            backdrop={backdrop}
            dialogClassName={position !== 'center' ? `modal-pair modal-pair-${position}` : undefined}
        >
            <Modal.Header>
                <Modal.Title>{t('extractedDataTitle')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className='text-muted mb-3 small'>{t('extractedDataSubtitle')}</p>
                <table className='table table-sm table-borderless mb-0'>
                    <tbody>
                        {FIELD_KEYS.map(({ key, labelKey }) => {
                            const value = data?.[key]
                            if (!value) return null
                            const isValid = validityMap[key]
                            const hasResult = key in validityMap
                            return (
                                <tr key={key}>
                                    <td className='text-muted' style={{ width: '40%' }}>{t(labelKey)}</td>
                                    <td className='fw-semibold'>{value}</td>
                                    <td style={{ width: '32px', textAlign: 'center' }}>
                                        {hasResult && (
                                            isValid
                                                ? <span style={{ color: '#198754', fontSize: '1.1rem' }}>✓</span>
                                                : <span style={{ color: '#dc3545', fontSize: '1.1rem' }}>✗</span>
                                        )}
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='success' onClick={onConfirm}>
                    {t('confirmAndContinue')}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}